import Class from './c-indicator-select';
import './c-indicator-select@';

export default Class;